import React, { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { api } from "../lib/api";

export default function OverdueBorrowAlert() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState({});

  useEffect(() => {
    api.get("/stock-outs/overdue").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  const visible = items.filter((i) => !dismissed[i.id]);
  if (!visible.length) return null;

  return (
    <div className="space-y-2 mb-4" data-testid="overdue-borrow-alerts">
      {visible.map((i) => (
        <div key={i.id} data-testid={`overdue-borrow-${i.id}`}
          className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 shrink-0" />
          <div className="flex-1 text-sm text-amber-900">
            Masih ada barang <b>{i.products?.join(", ") || "(tanpa nama)"}</b> yang dipinjam belum Kembali, harap followup ke <b>{i.borrower || "-"}</b>.
            <span className="ml-1 text-xs text-amber-700">
              (Stock Out {i.number} · estimasi kembali {i.expected_return_date} · telat {i.days_overdue} hari)
            </span>
          </div>
          <button type="button" onClick={() => setDismissed((d) => ({ ...d, [i.id]: true }))}
            data-testid={`overdue-dismiss-${i.id}`} className="text-amber-600 hover:text-amber-900" aria-label="Tutup">
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
